import React, { Component } from 'react';
import { connect } from 'react-redux';
// import spanish from '../../../../common/language/spanis';
// import english from '../../../../common/language/english';
import { ResortsActions } from '../../../../redux/resorts';
import BreadCrumb from './breadcrumb';
import Places from './places';
import Romms from './rooms';

// let lang = spanish;
class ResortInformation extends Component {

    // componentWillReceiveProps(next) {
    //     if (next.language === 'spanish') {
    //         lang = spanish;
    //     }
    //     else {
    //         lang = english;
    //     }
    // }

    render() {
        return (
            <div>
                <BreadCrumb/>
                <Places />
                <Romms/>
            </div>
        );
    }
}


const mapStateToProps = state => ({
    language: state.LanguageReducer.language,
});

const mapDispatchToProps = dispatch => ({
    setCurrentResort: (currentResort) => {
        dispatch(ResortsActions.setCurrentResort(currentResort));
    },
    setCurrentCity: (currentCity) => {
        dispatch(ResortsActions.setCurrentCity(currentCity));
    },
});

// make this component available to the app
export default connect(mapStateToProps, mapDispatchToProps)(ResortInformation);